import { render } from "./Drawings.vue?vue&type=template&id=bfb9785a"
import script from "./Drawings.vue?vue&type=script&lang=ts"
export * from "./Drawings.vue?vue&type=script&lang=ts"

import "./Drawings.vue?vue&type=style&index=0&id=bfb9785a&lang=scss"
script.render = render

export default script